import { Outlet, Navigate } from 'react-router-dom'

const PrivateRoute = () => {
    const token = localStorage.getItem('ridedriver_access_token');


  return (
    token  ? <Navigate  to="/dashboard"/> : <Outlet/>
  )
}

export default PrivateRoute